const criticalKeys = [
  'bank_id',
  'agency',
  'agency_digit',
  'account',
  'account_digit',
  'account_type',
  'name',
  'cpf_cnpj',
  'pix_key_type',
  'pix_key'
];
const pixKeys = ['pix_key_type', 'pix_key'];
const nonCriticalKeys = ['email'];

class DestinationBankAccountDataChangeValidationService {
  static hasChangedPixKeyData(dbData, dataToUpdate) {
    const changesQuantity = DestinationBankAccountDataChangeValidationService._changedKeysCount(
      dbData,
      dataToUpdate,
      pixKeys
    );
    return Boolean(changesQuantity);
  }

  static hasChangedCriticalData(dbData, dataToUpdate) {
    const changesQuantity = DestinationBankAccountDataChangeValidationService.getCriticalChangesQuantity(
      dbData,
      dataToUpdate
    );
    return Boolean(changesQuantity);
  }

  static getCriticalChangesQuantity(dbData, dataToUpdate) {
    return DestinationBankAccountDataChangeValidationService._changedKeysCount(dbData, dataToUpdate, criticalKeys);
  }

  static hasChangedNonCriticalData(dbData, dataToUpdate) {
    const changesQuantity = DestinationBankAccountDataChangeValidationService.getNonCriticalChangesQuantity(
      dbData,
      dataToUpdate
    );
    return Boolean(changesQuantity);
  }

  static getNonCriticalChangesQuantity(dbData, dataToUpdate) {
    return DestinationBankAccountDataChangeValidationService._changedKeysCount(dbData, dataToUpdate, nonCriticalKeys);
  }

  static setCriticalDataValues(source, target) {
    return DestinationBankAccountDataChangeValidationService._setKeyValues(source, target, criticalKeys);
  }

  static setNonCriticalDataValues(source, target) {
    return DestinationBankAccountDataChangeValidationService._setKeyValues(source, target, nonCriticalKeys);
  }

  static _changedKeysCount(source, target, keys) {
    return keys.filter(key => DestinationBankAccountDataChangeValidationService._hasKeyChanged(source, target, key))
      .length;
  }

  static _hasKeyChanged(source, target, key) {
    source = { ...source };
    target = { ...target };

    if (target[key] !== null && target[key] !== undefined) {
      // is not necessary compare zeros ahead of account or agency
      if (key === 'agency' || key === 'account') {
        source[key] = +source[key];
        target[key] = +target[key];
      }

      // BB accept x or X in yours agencies, we need guarantee that x is equal to X
      if (key === 'agency_digit' || key === 'account_digit') {
        source[key] = String(source[key]).toLowerCase();
        target[key] = String(target[key]).toLowerCase();
      }

      return source[key] != target[key];
    }

    return false;
  }

  static _setKeyValues(source, target, keys) {
    const updatedData = { ...source };

    for (const key of keys) {
      if (DestinationBankAccountDataChangeValidationService._hasKeyChanged(source, target, key)) {
        updatedData[key] = target[key];
      }
    }

    return updatedData;
  }
}

module.exports = DestinationBankAccountDataChangeValidationService;
